export default function Monogram({ size = 36, className = "" }) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 36 36"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <rect
        x="2"
        y="2"
        width="32"
        height="32"
        rx="4"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M10 12h8a5 5 0 0 1 0 10h-2l6 6"
        stroke="#2d7cf6"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
}
